<template>
  <div class="tabs">
    <el-tabs type="border-card" :stretch="true">
      <el-tab-pane>
        <span slot="label"><i class="el-icon-setting"></i> Home</span>
        <!-- Step1:输入 -->
        <div style="width: 100%">
          <div style="text-align: left">
            <h3>Choose the input type</h3>
            <p class="text_p">
              &nbsp;&nbsp;&nbsp;&nbsp;1.You can enter the patient's
              coagulation-inflammatory markers to obtain the patient's risk
              score and subphenotype.
            </p>
            <p class="text_p">
              &nbsp;&nbsp;&nbsp;&nbsp;2.Markers of coagulation-inflammation
              include aPTT, INR, lymphocyte, monocyte, neutrophil, WBC, PLT, and
              age.
            </p>
          </div>
          <el-button-group class="full-width-container">
            <el-button
              type="primary"
              icon="el-icon-edit-outline"
              @click="predictOneClick"
              plain
            >
              Sequence</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-document"
              @click="predictFileClick"
              plain
            >
              File Input</el-button
            >
          </el-button-group>
        </div>
        <!-- Step2:选择输入 -->
        <el-divider></el-divider>
        <!-- 2.1单样本输入 -->
        <div v-if="input_one">
          <div>
            <el-input
              placeholder="Normal Range: 24-37"
              v-model="inputData[0]['aPTT']"
            >
              <template style="width: 150px" slot="prepend">aPTT</template>
              <template slot="append">sec</template>
            </el-input>
          </div>
          <div style="margin-top: 10px">
            <el-input
              placeholder="Normal Range: 0.8-1.2"
              v-model="inputData[0]['INR']"
            >
              <template slot="prepend">INR</template>
            </el-input>
          </div>
          <div style="margin-top: 10px">
            <el-input
              placeholder="Normal Range: 1.1-3.2"
              v-model="inputData[0]['Lymphocyte']"
            >
              <template slot="prepend">Lymphocytes</template>
              <template slot="append">×10<sup>9</sup>/L</template>
            </el-input>
          </div>
          <div style="margin-top: 10px">
            <el-input
              placeholder="Normal Range: 0.1-0.6"
              v-model="inputData[0]['Monocyte']"
            >
              <template slot="prepend">Monocytes</template>
              <template slot="append">×10<sup>9</sup>/L</template>
            </el-input>
          </div>
          <div style="margin-top: 10px">
            <el-input
              placeholder="Normal Range: 1.8-6.3"
              v-model="inputData[0]['Neutrophil']"
            >
              <template slot="prepend">Neutrophils</template>
              <template slot="append">×10<sup>9</sup>/L</template>
            </el-input>
          </div>
          <div style="margin-top: 10px">
            <el-input
              placeholder="Normal Range: 4-10"
              v-model="inputData[0]['WBC']"
            >
              <template slot="prepend">WBC</template>
              <template slot="append">×10<sup>9</sup>/L</template>
            </el-input>
          </div>
          <div style="margin-top: 10px">
            <el-input
              placeholder="Normal Range: 125-350"
              v-model="inputData[0]['PLT']"
            >
              <template slot="prepend">PLT</template>
              <template slot="append">×10<sup>9</sup>/L</template>
            </el-input>
          </div>
          <div style="margin-top: 10px">
            <el-input
              placeholder="Value Range: 18-100"
              v-model="inputData[0]['Age']"
            >
              <template slot="prepend">Age</template>
              <template slot="append">year</template>
            </el-input>
          </div>
          <div class="container">
            <el-button @click="submitOneClick" class="left_button"
              >Submit</el-button
            >
            <el-popover
              placement="top-start"
              title="Explain"
              width="300"
              trigger="hover"
              class="right_button"
            >
              <p>
                <b>aPTT:</b> Activated partial thromboplastin time<br />
                <b>INR:</b> International normalized ratio<br />
                <b>WBC:</b> White blood cell count<br />
                <b>PLT:</b> Platelet count
              </p>
              <el-button type="text" slot="reference">Explain</el-button>
            </el-popover>
          </div>
        </div>
        <!-- 2.2批量输入   上传文件 -->
        <!-- http://43.139.254.55:8000/main/upload/ -->
        <!-- http://120.55.14.58:8000/main/upload/ -->
        <div v-if="input_file">
          <el-upload
            class="upload-demo"
            drag
            action="http://119.91.206.182:8000/main/upload/"
            multiple
            :on-success="successuploadfile"
            :on-error="erroruploadfile"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drag the file here, or <em> click Upload</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              Only supported .csv file
            </div>
          </el-upload>
        </div>
        <!-- 3.结果 -->
        <div v-if="result">
          <!-- 3.1单患者预测结果 -->
          <div v-if="result_one" style="text-align: left">
            <h3>Result</h3>
            <el-row :gutter="20">
              <el-col :span="8">
                <div>
                  <el-statistic title="Score">
                    <template
                      slot="formatter"
                      style="
                        display: flex;
                        justify-content: center;
                        aligh-items: center;
                        height: 100px;
                      "
                    >
                      <img
                        style="width: 112px; height: 112px"
                        :src="this.res_pred_one[0].url"
                      />
                      <!-- <div>{{ this.res_pred_one[0].score }}</div> -->
                    </template>
                  </el-statistic>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-statistic title="Risk Level">
                    <template
                      slot="formatter"
                      style="
                        display: flex;
                        justify-content: center;
                        aligh-items: center;
                        height: 100px;
                      "
                    >
                      <img
                        style="width: 90px; height: 90px"
                        :src="this.res_pred_one[1].url"
                      />
                      <div>{{ this.res_pred_one[1].risklevel }}</div>
                    </template>
                  </el-statistic>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-statistic title="Subphenotype">
                    <template
                      slot="formatter"
                      style="
                        display: flex;
                        justify-content: center;
                        aligh-items: center;
                        height: 100px;
                      "
                    >
                      <img
                        style="width: 60px; height: 90px"
                        :src="this.res_pred_one[2].url"
                      />
                      <div>{{ this.res_pred_one[2].subphenotype }}</div>
                    </template>
                  </el-statistic>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 3.2批量预测结果 -->
          <div v-if="result_file" style="text-align: left">
            <h3>Result</h3>
            <el-table :data="tableData" style="width: 100%" max-height="250">
              <el-table-column prop="Id" label="Id" width="80">
              </el-table-column>
              <el-table-column prop="aPTT" label="aPTT" width="120">
              </el-table-column>
              <el-table-column prop="INR" label="INR" width="120">
              </el-table-column>
              <el-table-column prop="Lymphocyte" label="Lymphocyte" width="120">
              </el-table-column>
              <el-table-column prop="Monocyte" label="Monocyte" width="120">
              </el-table-column>
              <el-table-column prop="Neutrophil" label="Neutrophil" width="120">
              </el-table-column>
              <el-table-column prop="WBC" label="WBC" width="120">
              </el-table-column>
              <el-table-column prop="PLT" label="PLT" width="120">
              </el-table-column>
              <el-table-column prop="Age" label="Age" width="120">
              </el-table-column>
              <el-table-column
                fixed="right"
                prop="Score"
                label="Score"
                width="120"
              >
              </el-table-column>
              <el-table-column
                fixed="right"
                prop="RiskLevel"
                label="RiskLevel"
                width="120"
              >
              </el-table-column>
              <el-table-column
                fixed="right"
                prop="Subphenotype"
                label="Subphenotype"
                width="120"
              >
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="pageSizes"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="this.total"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Tutorial">
        <span slot="label"><i class="el-icon-set-up"></i> Tutorial</span>
        <div style="text-align: left">
          <h2>How to use</h2>
          <p class="text_p">
            &nbsp;&nbsp;&nbsp;&nbsp;1.Select input type (Sequence or Input
            file).
          </p>
          <p class="text_p">
            &nbsp;&nbsp;&nbsp;&nbsp;2.Sequence Input: Sequence requires input of
            the patient's seven routine laboratory blood measurements and age.
          </p>
          <p class="text_p">
            &nbsp;&nbsp;&nbsp;&nbsp;3.File Input: user can upload a .csv file.
          </p>
          <p class="text_p">
            &nbsp;&nbsp;&nbsp;&nbsp;4.<a href="http://119.91.206.182/data.csv"
              >Example file</a
            >
          </p>
          <h2>About the output</h2>
          The output contains these information:
          <p class="text_p">&nbsp;&nbsp;&nbsp;&nbsp;1. Patient risk score</p>
          <p class="text_p">&nbsp;&nbsp;&nbsp;&nbsp;2. Patient risk level</p>
          <p class="text_p">&nbsp;&nbsp;&nbsp;&nbsp;3. Patient Subphenotype</p>
        </div>
      </el-tab-pane>
      <el-tab-pane label="About">
        <span slot="label"><i class="el-icon-more-outline"></i> About</span>
        <div style="text-align: left; display: flex; flex-direction: column">
          <h2 style="text-align: left">What is SMART</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;<b>SMART</b> is a risk stratification tool
            built using a minimal subset of coagulation-inflammatory markers.
            The SMART develops a clinically relevant scorecard based on medical
            knowledge, classifying sepsis into four risk levels:<br />
            &nbsp;&nbsp;&nbsp;&nbsp;<b>Mild:[4,9)</b>
            <br />&nbsp;&nbsp;&nbsp;&nbsp;<b>Moderate:[9,13）</b
            ><br />&nbsp;&nbsp;&nbsp;&nbsp;<b>Severe:[13,17)</b
            ><br />&nbsp;&nbsp;&nbsp;&nbsp;<b>Dangerous:[17,20]</b><br />
            &nbsp;&nbsp;&nbsp;&nbsp;The SMART enable physicians to rapidly
            assess patient acuity and optimize patient management. Tailored
            therapeutic strategies can be implemented based on varying risk
            levels, focusing resources on those most in need and mitigating both
            over- and under-treatment.
          </p>
          <el-card class="box-card" style="text-align: center">
            <img
              style="width: 100%; height: 100%"
              src="../assets/scorecard.png"
            />
          </el-card>
        </div>
        <div style="text-align: left">
          <h2>What is Subphenotype</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;An unsupervised approach is used to derive
            subphenotypes in sepsis based on routine laboratory measurements.
            Specifically, two distinct clusters are identified as subphenotypes
            by GMM using only coagulation-inflammatory markers to explore the
            heterogeneity of patients with sepsis, named
            <b>Coagulation-Inflammatory Sepsis 1 (CIS1)</b> and
            <b>Coagulation-Inflammatory Sepsis 2 (CIS2)</b>. CIS2 subphenotype
            presents with more severe inflammatory and coagulative syndromes
            compared to CIS1.
          </p>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
  
<script>
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

// 设置语言
locale.use(lang);
export default {
  name: "Home",
  props: {
    msg: String,
  },
  data() {
    return {
      input_one: false,
      input_file: false,
      result: false,
      result_one: false,
      result_file: false,
      inputData: [
        {
          aPTT: "",
          INR: "",
          Lymphocyte: "",
          Monocyte: "",
          Neutrophil: "",
          WBC: "",
          PLT: "",
          Age: "",
        },
      ],
      tableData: [], // 当前页码的表格数据
      tableallData: [],
      res_pred_one: [
        {
          score: "",
          url: "",
        },
        {
          risklevel: "",
          url: "",
        },
        {
          subphenotype: "",
          url: "",
        },
      ],
      currentPage: 1,
      total: 0,
      pageSize: 10, // 当前页容量
      pageSizes: [10, 20, 50, 100],
    };
  },
  methods: {
    predictOneClick() {
      this.input_one = true;
      this.input_file = false;
      this.result = false;
      this.result_one = false;
      this.result_file = false;
    },
    predictFileClick() {
      this.input_file = true;
      this.input_one = false;
      this.result = false;
      this.result_one = false;
      this.result_file = false;
    },
    submitOneClick() {
      var aPTTnum = parseFloat(this.inputData[0].aPTT);
      if (aPTTnum < 0.0) {
        this.$message({
          message: "aPTT must > 0.0.",
          type: "warning",
        });
        return;
      } else if (Number.isNaN(aPTTnum)) {
        this.$message({
          message: "aPTT must is float number.",
          type: "warning",
        });
        return;
      }

      var INRnum = parseFloat(this.inputData[0].INR);
      if (INRnum < 0.0) {
        this.$message({
          message: "INR must > 0.0.",
          type: "warning",
        });
        return;
      } else if (Number.isNaN(INRnum)) {
        this.$message({
          message: "INR must is float number.",
          type: "warning",
        });
        return;
      }

      var Lymphocytenum = parseFloat(this.inputData[0].Lymphocyte);
      if (Lymphocytenum < 0.0) {
        this.$message({
          message: "Lymphocyte must > 0.0.",
          type: "warning",
        });
        return;
      } else if (Number.isNaN(Lymphocytenum)) {
        this.$message({
          message: "Lymphocyte must is float number.",
          type: "warning",
        });
        return;
      }

      var Monocytenum = parseFloat(this.inputData[0].Monocyte);
      if (Monocytenum < 0.0) {
        this.$message({
          message: "Monocyte must > 0.0.",
          type: "warning",
        });
        return;
      } else if (Number.isNaN(Monocytenum)) {
        this.$message({
          message: "Monocyte must is float number.",
          type: "warning",
        });
        return;
      }

      var Neutrophilnum = parseFloat(this.inputData[0].Neutrophil);
      if (Neutrophilnum < 0.0) {
        this.$message({
          message: "Neutrophil must > 0.0.",
          type: "warning",
        });
        return;
      } else if (Number.isNaN(Neutrophilnum)) {
        this.$message({
          message: "Neutrophil must is float number.",
          type: "warning",
        });
        return;
      }

      var WBCnum = parseFloat(this.inputData[0].WBC);
      if (WBCnum < 0.0) {
        this.$message({
          message: "WBC must > 0.0.",
          type: "warning",
        });
        return;
      } else if (Number.isNaN(WBCnum)) {
        this.$message({
          message: "WBC must is float number.",
          type: "warning",
        });
        return;
      }

      var PLTnum = parseFloat(this.inputData[0].PLT);
      if (PLTnum < 0.0) {
        this.$message({
          message: "PLT must > 0.0.",
          type: "warning",
        });
        return;
      } else if (Number.isNaN(PLTnum)) {
        this.$message({
          message: "PLT must is float number.",
          type: "warning",
        });
        return;
      }

      var Agenum = parseFloat(this.inputData[0].Age);
      if (Agenum < 18.0) {
        this.$message({
          message: "Age must > 18.0.",
          type: "warning",
        });
        return;
      } else if (Number.isNaN(Agenum)) {
        this.$message({
          message: "Age must is float number.",
          type: "warning",
        });
        return;
      }
      // http://43.139.254.55:8000/main/predictone/
      // 120.55.14.58
      this.$axios
        .post("http://119.91.206.182:8000/main/predictone/", this.inputData)
        .then((res) => {
          this.res_pred_one[0].score = String(res.data["score"]);
          this.res_pred_one[0].url="http://119.91.206.182/"+String(res.data["score"])+".png"
          this.res_pred_one[1].risklevel = String(res.data["risklevel"]);
          this.res_pred_one[1].url="http://119.91.206.182/"+String(res.data["risklevel"])+".png"
          this.res_pred_one[2].subphenotype = String(res.data["subphenotype"]);
          this.res_pred_one[2].url="http://119.91.206.182/"+String(res.data["subphenotype"])+".png"
          this.result = true;
          this.result_one = true;
        });
    },
    successuploadfile(res) {
      this.tableallData = res.res;
      this.tableData = this.getNeedArr(this.tableallData, this.pageSize)[
        this.currentPage - 1
      ]; // 当前页的表格数据
      this.total = res.res.length;
      this.result = true;
      this.result_file = true;
      this.input_file = false;
    },
    erroruploadfile() {
      this.$message.error("上传失败!");
      // this.result=true;
      // this.result_file=true;
    },
    // 分页
    // 切换每页条数容量
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.tableData = this.getNeedArr(this.tableallData, this.pageSize)[
        this.currentPage - 1
      ]; // 当前页的表格数据
    },
    // 切换当前页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.tableData = this.getNeedArr(this.tableallData, this.pageSize)[
        this.currentPage - 1
      ]; // 当前页的表格数据
    },
    getNeedArr(array, size) {
      // 获取所需指定长度分割的数组;参数1为用于分割的总数组,参数2为分割数组后每个小数组的长度
      const length = array.length;
      // 判断不是数组，或者size没有设置，size小于1，就返回空数组
      if (!length || !size || size < 1) {
        return [];
      }

      let index = 0; // 用来表示切割元素的正常start
      let resIndex = 0; // 用来递增表示输出数组的下标

      // 根据length和size算出输出数组的长度，并且创建它。
      let result = new Array(Math.ceil(length / size));
      // 进行循环
      while (index < length) {
        // 循环过程中设置result[0]和result[1]的值。该值根据array.slice切割得到。
        result[resIndex++] = array.slice(index, (index += size));
      }
      // 输出到新数组
      return result;
    },
  },
};
</script>
<style scoped>
.tabs {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 60%;
}
@media (max-width: 600px) {
  .tabs {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
}
.full-width-container {
  display: flex;
  width: 100%;
}
.el-button {
  flex: 1;
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
}
.left_button {
  padding: 10px 20px;
  width: auto;
}
.right_button {
  padding: 10px 20px;
  width: auto;
}
.text_p {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  unicode-bidi: isolate;
}
::v-deep .el-input-group__prepend {
  border-right: 0;
  width: 100px;
}
::v-deep .el-input-group__append {
  border-right: 0;
  width: 100px;
}
</style>
  